var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04 2.2399C3.09026 1.18964 4.51471 0.599609 6 0.599609C7.48529 0.599609 8.90974 1.18964 9.96 2.2399C11.0103 3.29015 11.6003 4.71461 11.6003 6.1999C11.6003 7.68518 11.0103 9.10964 9.96 10.1599L6 14.1199L2.04 10.1599C1.51993 9.63988 1.10739 9.02252 0.825926 8.34305C0.544464 7.66359 0.399597 6.93535 0.399597 6.1999C0.399597 5.46445 0.544464 4.7362 0.825926 4.05674C1.10739 3.37728 1.51993 2.75991 2.04 2.2399ZM6 7.7999C6.42435 7.7999 6.83131 7.63132 7.13137 7.33127C7.43143 7.03121 7.6 6.62424 7.6 6.1999C7.6 5.77555 7.43143 5.36858 7.13137 5.06852C6.83131 4.76847 6.42435 4.5999 6 4.5999C5.57565 4.5999 5.16869 4.76847 4.86863 5.06852C4.56857 5.36858 4.4 5.77555 4.4 6.1999C4.4 6.62424 4.56857 7.03121 4.86863 7.33127C5.16869 7.63132 5.57565 7.7999 6 7.7999Z",
    fill: "#D1D5DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.7133fb5ff2f9d66787f6ed4988d871a7.svg";
export { ForwardRef as ReactComponent };